import _defineProperty from "/app/vetiver/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/app/vetiver/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import clsx from 'clsx';
import React, { useRef, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import MenuItem from '@material-ui/core/MenuItem';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ListItemText from '@material-ui/core/ListItemText';
import { makeStyles } from '@material-ui/core/styles';
import { PopoverMenu } from '../../../components/PopoverMenu';
import { MButton } from '../../../@material-extend/Buttons/MButton';
import { LANGUAGES } from '../../../models/constants/global.constant';
var useStyles = makeStyles(function (theme) {
  return {
    menuItem: {
      whiteSpace: 'pre-wrap',
      padding: '8px 20px !important',
      '& $span': {
        fontSize: '14px',
        fontFamily: 'Poppins-Regular'
      },
      '&:hover': {
        background: '#F4F6F8 !important',
        borderRadius: '8px !important'
      }
    },
    btnLang: {
      width: 'auto',
      height: '42px',
      fontSize: '16px',
      color: '#212121 !important',
      fontFamily: 'Poppins-Regular',
      padding: '10px 18px 10px 8px',
      '&:hover': {
        background: '#F4F6F8 !important',
        borderRadius: '8px'
      },
      '& .MuiButton-endIcon': {
        marginLeft: '10px',
        color: '#434242',
        textTransform: 'uppercase',
        '& :nth-of-type(1)': {
          fontSize: '22px'
        }
      },
      textTransform: 'uppercase'
    },
    isSelected: {
      backgroundColor: theme.palette.background.neutral
    },
    isItemSelected: {
      background: '#F4F6F8 !important',
      borderRadius: '8px !important'
    },
    fontBold: {
      '& .MuiTypography-root': {
        fontFamily: 'Poppins-Bold'
      }
    },
    fontWeight900: {
      '& .MuiTypography-root': {
        fontWeight: 900
      }
    }
  };
});
export var DesktopLangMenu = function DesktopLangMenu(_ref) {
  var changeLang = _ref.changeLang,
      currentLanguageLabel = _ref.currentLanguageLabel;
  var classes = useStyles();
  var anchorRef = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  var LangChunkSize = Math.ceil(LANGUAGES.length / 3);
  return React.createElement(React.Fragment, null, React.createElement(MButton, {
    ref: anchorRef,
    onClick: function onClick() {
      return setOpen(true);
    },
    endIcon: React.createElement(ExpandMore, {
      style: {
        fontSize: '22px'
      }
    }),
    className: clsx(classes.btnLang, _defineProperty({}, classes.isSelected, isOpen))
  }, currentLanguageLabel.toUpperCase()), React.createElement(PopoverMenu, {
    width: 600,
    open: isOpen,
    onClose: function onClose() {
      return setOpen(false);
    },
    anchorEl: anchorRef.current
  }, React.createElement(Box, {
    sx: {
      py: 1
    }
  }, React.createElement(Grid, {
    container: true,
    spacing: 0
  }, [0, 1, 2].map(function (i) {
    return React.createElement(Grid, {
      item: true,
      xs: 4,
      key: i
    }, LANGUAGES.slice(i * LangChunkSize, (i + 1) * LangChunkSize).map(function (option) {
      return React.createElement(MenuItem, {
        key: option.code,
        onClick: function onClick() {
          return changeLang(option.code);
        },
        className: clsx(classes.menuItem, option.code === currentLanguageLabel && classes.isItemSelected)
      }, React.createElement(ListItemText, {
        className: clsx(option.code === currentLanguageLabel && classes.fontWeight900),
        primaryTypographyProps: {
          variant: 'body2'
        }
      }, option.name));
    }));
  })))));
};